import React, { useEffect } from "react";

/**
 * Attaches an IntersectionObserver to elements marked with .reveal so
 * they fade-up into view once. Runs once on mount.
 */
export function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    if (!("IntersectionObserver" in window)) {
      els.forEach((el) => el.classList.add("in"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -10% 0px" },
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}

export const Reveal = ({ as: Tag = "div", delay = 0, className = "", children, ...rest }) => (
  <Tag
    className={`reveal ${className}`}
    style={{ transitionDelay: `${delay}ms` }}
    {...rest}
  >
    {children}
  </Tag>
);
